import {observer} from 'mobx-react'
import React from 'react'
import {FlatList, Image, RefreshControl, Text, View} from 'react-native'
import {
  FooterBar,
  FooterBarButton,
  FooterBarIconButton,
  ImageCard,
  ImageTextCard,
  MyButton,
  MyFooter,
  MyFooterTile,
  ToprScreenLoader,
} from '../../../../Components'
import {navigate} from '../../../../Helpers/NavigationHelper'
import {GetLocalizedImageUrl, GetRandomKey} from '../../../../Helpers/UiHelpers'
import i18n from '../../../../i18n'
import I18n from '../../../../i18n'
import Style, {colors} from '../../../../Style'
import {dashboardStore} from '../../Dashboard/Store'
import {dashboardHeaderStore} from '../DashboardHeader/Store'
import {LastItem} from '../../../../Helpers/ArrayHelpers'
interface IProps {}

const CouponsTab: React.FC<IProps> = ({children}) => {
  const {GroupedCoupons, IsCouponsLoading} = dashboardStore
  const {defaultFlatList, flatListContentStyle} = Style
  return (
    <ToprScreenLoader isLoading={IsCouponsLoading}>
      <FlatList
        bounces={false}
        onScroll={(event) => {
          dashboardHeaderStore.SetScrollY(event.nativeEvent.contentOffset.y)
        }}
        ListEmptyComponent={
          <ImageCard
            imageUrl="https://images.unsplash.com/photo-1594968973184-9040a5a79963?ixlib=rb-1.2.1&ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&auto=format&fit=crop&w=1050&q=80"
            text={I18n.t('Dashboard.NoCoupons')}
          />
        }
        style={[
          defaultFlatList,
          {
            paddingTop: dashboardHeaderStore.HEADER_MAX_HEIGHT * 2,
          },
        ]}
        refreshControl={
          <RefreshControl
            refreshing={IsCouponsLoading}
            progressViewOffset={dashboardHeaderStore.HEADER_MAX_HEIGHT * 2}
            onRefresh={() => {
              dashboardStore.GetUserCoupons()
            }}
          />
        }
        contentContainerStyle={[flatListContentStyle]}
        data={GroupedCoupons}
        renderItem={({item}) => {
          const lastItem = LastItem(GroupedCoupons)
          return (
            <ImageTextCard
              isLast={lastItem?.Coupon.Guid === item.Coupon.Guid}
              key={item.UserCoupons[0].UserCouponGUID}
              imageUrl={GetLocalizedImageUrl(item.Coupon.Images[0].Guid)}
              title={item.Coupon.FullTitle}
              onPress={() => {
                navigate('couponDetails', {
                  userCouponGuid: item.UserCoupons[0].UserCouponGUID,
                })
              }}
              badgeText={`${item.UserCoupons.length}x`}
            />
          )
        }}
        keyExtractor={() => {
          return GetRandomKey()
        }}
      />
      <FooterBar>
        <FooterBarIconButton
          icon={{name: 'qrcode', type: 'font-awesome'}}
          onPress={() => navigate('qrCode')}
          text={i18n.t('Common.Redeem')}
        />

        <FooterBarButton
          icon={{name: 'table', type: 'antdesign'}}
          text={i18n.t('Common.Summary')}
          onPress={() => {
            navigate('couponsSummary')
          }}
        />
      </FooterBar>
    </ToprScreenLoader>
  )
}

export default observer(CouponsTab)
